import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { bodyText, colours, visuallyHidden } from '../player/playerStyles'
import { screenTitle } from '../player/screens'
import BranchingScenario from './BranchingScenario'
import Callout from './Callout'
import CaseStudy from './CaseStudy'
import CourseIntro from './CourseIntro'
import DownloadBlock from './DownloadBlock'
import FurtherLearning from './FurtherLearning'
import Hotspot from './Hotspot'
import HowToUse from './HowToUse'
import Illustration from './Illustration'
import KnowledgeCheck from './KnowledgeCheck'
import Match from './Match'
import ModuleIntro from './ModuleIntro'
import PracticalSignoffInfo from './PracticalSignoffInfo'
import Reflection from './Reflection'
import RevealCards from './RevealCards'
import Sequence from './Sequence'
import SummaryBlock from './SummaryBlock'
import TextBlock from './TextBlock'
import VideoBlock from './VideoBlock'

const BLOCKS = {
  courseIntro: CourseIntro,
  howToUse: HowToUse,
  moduleIntro: ModuleIntro,
  text: TextBlock,
  illustration: Illustration,
  callout: Callout,
  caseStudy: CaseStudy,
  revealCards: RevealCards,
  hotspot: Hotspot,
  sequence: Sequence,
  match: Match,
  branchingScenario: BranchingScenario,
  knowledgeCheck: KnowledgeCheck,
  reflection: Reflection,
  video: VideoBlock,
  download: DownloadBlock,
  summary: SummaryBlock,
  furtherLearning: FurtherLearning,
  practicalSignoff: PracticalSignoffInfo,
}

// A small label above the heading that says what kind of screen this is.
const KIND_LABELS = {
  revealCards: 'Activity',
  hotspot: 'Activity',
  sequence: 'Activity',
  match: 'Activity',
  branchingScenario: 'Scenario activity',
  knowledgeCheck: 'Check your understanding',
  reflection: 'Reflection',
  summary: 'Summary',
}

// One screen: the heading (an h2 the player moves focus to when the screen
// changes) and the component for the block's type.
//
// Every block component receives { block, module, content, initialState,
// completed, onStateChange, onSave }. Activities report each change through
// onStateChange; reflections also call onSave when the learner saves.
const BlockRenderer = ({ block, module, content, initialState, completed, onStateChange, onSave, headingRef }) => {
  const Component = BLOCKS[block.type]
  // An untitled illustration still needs a heading to land on, but not a
  // visible one.
  const hideHeading = block.type === 'illustration' && !block.title
  const kind = KIND_LABELS[block.type]

  return (
    <Box>
      {kind && (
        <Typography sx={{ fontSize: '0.9375rem', fontWeight: 700, color: colours.muted, mb: 0.5 }}>{kind}</Typography>
      )}
      <Typography
        component="h2"
        ref={headingRef}
        tabIndex={-1}
        sx={{
          fontSize: { xs: '1.3125rem', sm: '1.5rem' },
          fontWeight: 700,
          lineHeight: 1.3,
          color: colours.text,
          mb: 2,
          scrollMarginTop: 16,
          ...(hideHeading ? visuallyHidden : null),
        }}
      >
        {screenTitle(block, module)}
      </Typography>
      {Component ? (
        <Component
          block={block}
          module={module}
          content={content}
          initialState={initialState}
          completed={completed}
          onStateChange={onStateChange}
          onSave={onSave}
        />
      ) : (
        <Typography sx={bodyText}>This screen cannot be shown here. You can carry on to the next one.</Typography>
      )}
    </Box>
  )
}

export default BlockRenderer
